var map = {
	"./Alhamra.jpg": 112,
	"./Bagan.jpg": 113,
	"./Capadocia.jpg": 114,
	"./Dara.jpg": 115,
	"./Eflatun.jpg": 116,
	"./Eternity.jpg": 117,
	"./Gold.jpg": 118,
	"./Hattusas.jpg": 119,
	"./Hill.jpg": 120,
	"./Inca.jpg": 121,
	"./Ladakh.jpg": 122,
	"./Liberty.jpg": 123,
	"./Mahi.jpg": 124,
	"./Meterhorn.jpg": 125,
	"./Petra.jpg": 126,
	"./Portofino.jpg": 127,
	"./Pyramid.jpg": 128,
	"./Queen.jpg": 129,
	"./Sahara.jpg": 130,
	"./Stonehenge.jpg": 131,
	"./Treasury.jpg": 132,
	"./Valley.jpg": 133,
	"./Victoria.jpg": 134,
	"./Zel.jpg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;